import {HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { TokenStorageService } from "../services/token-storage.service";
import {catchError} from "rxjs/operators";
import {AuthenticationService} from "../services/authentication.service";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";

// const TOKEN_HEADER_KEY = 'Authorization';       // for Spring Boot back-end
const TOKEN_HEADER_KEY = 'x-access-token';   // for Node.js Express back-end

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private token: TokenStorageService,
    private authService: AuthenticationService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const token = this.token.getToken();
    if (token != null) {
      // for Spring Boot back-end
      // authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });

      // for Node.js Express back-end
      authReq = req.clone({ headers: req.headers.set(TOKEN_HEADER_KEY, token) });
    }
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // 🔹 401 = expired/invalid session: remove token and redirect to login.
        if (error.status === 401) {
          // Remove token and redirect to login
          this.authService.removeToken().then(() => {
            if (!this.router.url.startsWith("/auth")) {
              this.toastr.warning("Your session has expired. Please log in again.");
              this.router.navigateByUrl("/auth/login2", { replaceUrl: true });
            }
          });
        }
        // 🔹 403 = authenticated but not permitted. Do NOT remove the token and
        // do NOT redirect to login here. The 403 -> unauthorized-page navigation
        // is owned by ErrorInterceptor; this interceptor just rethrows so
        // component handlers can still react.
        return throwError(() => error);
      })
    );

  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
];
